import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CmsManagementService {
  cmsMode: boolean = false;
  cmsModeChanged= new Subject<boolean>();
  selectedTranslationObj = new Subject<any>();


  constructor() {
    // Retrieve CMS mode from localStorage on service initialization
    this.cmsMode = JSON.parse(localStorage.getItem("cmsMode"));
  }

  setCMSMode(value: boolean): void {
    // Set CMS mode in service variable
    this.cmsMode = value;

    this.cmsModeChanged.next(value);

    // Save CMS mode in localStorage
    localStorage.setItem("cmsMode", JSON.stringify(value));
  }

  getCMSMode(): boolean {
    // Return CMS mode from service variable
    return this.cmsMode;
  }
}
